import { fetchGet, createParamGet } from '../utilities/ServiceUtils';
import * as ApiConstants from '../constants/ApiConstants';

const formatParameters = (parameters) => {
    const formattedParameters = { ...parameters };
    Object.keys(parameters).forEach((key) => {
        const value = parameters[key];
        if (parameters[key] instanceof Date) {
            formattedParameters[key] = value.toISOString();
        }
    });
    return createParamGet(formattedParameters);
};

export const fetchAttendanceHistory = async (parameters) => {
    try {
        const fetchData = await fetchGet(
            `${
                ApiConstants.SERVICE_TIME_CLOCK_ATTENDANCE_HISTORY
            }?${formatParameters(parameters)}`
        );
        if (!fetchData.ok) {
            throw fetchData.statusText;
        }
        const response = await fetchData.json();
        return response;
    } catch (error) {
        console.log('ex fetchAttendanceHistory : ', error);
    }
};

export const fetchAttendanceHistoryDetails = async (parameters) => {
    try {
        const fetchData = await fetchGet(
            `${
                ApiConstants.SERVICE_TIME_CLOCK_ATTENDANCE_HISTORY_DETAILS
            }?${formatParameters(parameters)}`
        );
        if (!fetchData.ok) {
            throw fetchData.statusText;
        }
        const response = await fetchData.json();
        return response;
    } catch (error) {
        console.log('ex fetchAttendanceHistoryDetails : ', error);
    }
};

export const fetchPastWorkHistory = async (parameters) => {
    try {
        const fetchData = await fetchGet(
            `${
                ApiConstants.SERVICE_TIME_CLOCK_PAST_WORK_HISTORY
            }?${formatParameters(parameters)}`
        );
        if (!fetchData.ok) {
            throw fetchData.statusText;
        }
        const response = await fetchData.json();
        return response;
    } catch (error) {
        console.log('ex fetchPastWorkHistory : ', error);
    }
};

export const fetchSapHistory = async (parameters) => {
    try {
        const fetchData = await fetchGet(
            `${ApiConstants.SERVICE_TIME_CLOCK_SAP_HISTORY}?${formatParameters(
                parameters
            )}`
        );
        if (!fetchData.ok) {
            throw fetchData.statusText;
        }
        const response = await fetchData.json();
        return response;
    } catch (error) {
        console.log('ex fetchSapHistory : ', error);
    }
};

export const fetchMeaBoundary = async () => {
    try {
        const fetchData = await fetchGet(
            ApiConstants.SERVICE_TIME_CLOCK_MEA_BOUNDARY
        );
        if (!fetchData.ok) {
            throw fetchData.statusText;
        }
        const response = await fetchData.json();
        return response;
    } catch (error) {
        console.log('ex fetchMeaBoundary : ', error);
    }
};

export const updateMeaBoundary = async (parameters) => {
    try {
        const fetchData = await fetch(
            ApiConstants.SERVICE_TIME_CLOCK_MEA_BOUNDARY,
            {
                method: 'PUT',
                body: parameters,
                headers: {
                    'x-api-key': process.env.REACT_APP_API_KEY,
                },
            }
        );
        if (!fetchData.ok) {
            throw fetchData.statusText;
        }
        const response = await fetchData.json();
        return response;
    } catch (error) {
        console.log('ex getTransaction : ', error);
    }
};

export const exportSapHistory = async (parameters) => {
    try {
        const fetchData = await fetchGet(
            `${
                ApiConstants.SERVICE_TIME_CLOCK_EXPORT_SAP_HISTORY
            }?${formatParameters(parameters)}`
        );
        if (!fetchData.ok) {
            throw fetchData.statusText;
        }
        const response = await fetchData.blob();

        return response;
    } catch (error) {
        console.log('ex exportSapHistory : ', error);
    }
};

export const exportPastWorkHistory = async (parameters) => {
    try {
        const fetchData = await fetchGet(
            `${
                ApiConstants.SERVICE_TIME_CLOCK_EXPORT_PAST_WORK_HISTORY
            }?${formatParameters(parameters)}`
        );
        if (!fetchData.ok) {
            throw fetchData.statusText;
        }
        const response = await fetchData.blob();

        return response;
    } catch (error) {
        console.log('ex exportPastWorkHistory : ', error);
    }
};

export const exportAttendanceHistory = async (parameters) => {
    try {
        const fetchData = await fetchGet(
            `${
                ApiConstants.SERVICE_TIME_CLOCK_EXPORT_ATTENDANCE_HISTORY
            }?${formatParameters(parameters)}`
        );
        if (!fetchData.ok) {
            throw fetchData.statusText;
        }
        const response = await fetchData.blob();

        return response;
    } catch (error) {
        console.log('ex exportAttendanceHistory : ', error);
    }
};
